<template>
  <LayoutContainer :id="data.cssId">
    <UtilityHeadline
      v-if="data.headlineH2"
      :class="`dbc-text-color-${data.headlineH2Color}`"
      :text="data.headlineH2"
      :level="2"
      :aos="{ fadeDirection: 'fade-right', delay: 350 }"
      :category="{ text: data.categoryH2, color: data.categoryH2Color }"
    />

    <details
      v-for="detail in data.content"
      :key="detail.id"
      class="my-4 bg-gray group"
    >
      <summary
        class="p-4 cursor-pointer list-none font-bold hover:text-primary flex items-center justify-between group-open:text-primary"
      >
        {{ detail.headline }}
        <DbcSvg
          name="dbc-icon-chevron-down"
          class="duration-300 group-open:-rotate-180"
        />
      </summary>
      <UtilityText :text="detail.text" class="p-4" />
    </details>
  </LayoutContainer>
</template>

<script setup lang="ts">
const props = defineProps<{
  content: ContentAccordion
}>()
const data = normalizeContentAccordion(props.content)
</script>
